module.exports = __webpack_public_path__ + "static/W.Brown-Brixton Ramblers-68de60a2c38bbd114689eccb8e95d35a.jpg";